import { cleartaxAxios, cmsAxios } from '../../../http-common';
import { CMS_PAGINATION_LIMIT } from '../layout/constants';

class CMSPageDataServices {
  getSinglePagebyID(postID: number) {
    return cmsAxios.get(
      `/f/content_management/post/${postID}/?show_deep_category=1`
    );
  }

  getPageByURL(pageURL: string, domain = 1, language = 1, contentType = 'cms') {
    return cmsAxios.get(
      `/f/content_management/post/get_by_permalink/${pageURL}/?show_deep_category=1&domain=${domain}&language=${language}&content_type=${contentType}`
    );
  }

  getPaginatedPages(
    nextPage: number,
    domainVal: number,
    language = 1,
    PAGINATIONLIMIT = CMS_PAGINATION_LIMIT,
    content_type = 'cms'
  ) {
    return cmsAxios.get(
      `/f/content_management/post/?page=${nextPage}&limit=${PAGINATIONLIMIT}&domain=${domainVal}&show_deep_category=1&language=${language}&content_type=${content_type}&status=publish`
    );
  }

  getAllAuthors(domainVal: number, page: number, limit: number) {
    return cmsAxios.get(
      `/f/content_management/author/?domain=${domainVal}&page=${page}&limit=${limit}`
    );
  }

  getAuthorPostsBySlug(slug: string, domainVal: number, page: number) {
    return cmsAxios.get(
      `/f/content_management/author/${slug}/posts/?domain=${domainVal}&page=${page}`
    );
  }

  //Don't change it to cmsAxios as it is used in client side
  getAllURLs(domainVal: number, language = 1) {
    return cleartaxAxios.get(
      `/f/content_management/post/get_all_permalinks/?domain=${domainVal}&layout=Layout2021&status=publish&noIndex=0&language=${language}`
    );
  }

  //Don't change it to cmsAxios as it is used in client side
  getReusableComponent(externalID: string) {
    return cleartaxAxios.get(
      `f/content_management/reusable-component/${externalID}/`
    );
  }

  getTrendingPosts(domainVal = 1) {
    return cmsAxios.get(
      `/f/content_management/post/get_all_permalinks/?domain=${domainVal}&content_type=glossary&ordering=-updated_at`
    );
  }
}
export default new CMSPageDataServices();
